module.exports = __webpack_public_path__ + "img/Slide25.334e619d.png";